import * as pmWsOperations from './operations';

export {
    pmWsOperations
};
